/**
 * Mã lỗi ghi sổ
 * NNLINH 12.07.2022
 */
export default {
  // Warning
  Post_Voucher_InGLVoucherList:
    'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại hoặc bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
  Post_Voucher_InVoucherSummary:
    'Chứng từ này đã được lập trong bảng tổng hợp chứng từ cùng loại. Chương trình sẽ tự động loại bỏ chứng từ này nếu thấy không hợp lệ.',
  Post_Voucher_InBUVoucherList:
    'Chứng từ này đã lập bảng kê. Chương trình sẽ tự động loại bỏ chứng từ này nếu chứng từ không hợp lệ.',
  Post_ExsistTAPurchaseSaleList:
    'Chương trình đã tự động loại bỏ hạch toán chi tiết có thay đổi thông tin nhóm HHDV ra khỏi bảng kê mua vào/bán ra.',
  UnPost_Warning_OutwardBeUpdated:
    'Chứng từ <span class="color-blue">{0}</span> đã được chọn để lập các chứng từ <span class="color-blue">{1}</span>. Bạn phải bỏ ghi chứng từ xuất trước khi bỏ ghi chứng từ này.',

  // Error
  Post_ValidateVerifyAccount: 'Định khoản không hợp lệ. Ghi sổ không thành công.',
  Post_NotZeroAmount: 'Giá trị hạch toán phải khác 0. Ghi sổ không thành công.',
  Post_VoucherInvalid: 'Thiếu thông tin hạch toán. Vui lòng kiểm tra lại',
  Post_VoucherInvalidDate: 'Ngày hạch toán phải lớn hơn ngày khóa sổ. Xin vui lòng kiểm tra lại.',
  Post_FixedAsset_RequiredFixedAsset: 'Lỗi khi ghi chứng từ vào sổ tài sản: thiếu tài sản. Ghi sổ không thành công',
  Post_FixedAsset_RequiredDepartment: 'Lỗi khi ghi chứng từ vào sổ tài sản: thiếu phòng ban. Ghi sổ không thành công',
  Post_ValidAccDetailBy_AccountingObject: 'Đối tượng',
  
  Post_ValidConfrontingRefIDForRealName:
    '<div class="content-error">Vật tư <span class="color-green">{0}-{1}</span> chưa xác định đích danh chứng từ nhập. Ghi sổ không thành công.</div>',
  Post_ValidateOutwardQuantityRealName:
    '<div class="content-error">Không thể xuất Vật tư <span class="color-green">{0}-{1}</span> quá số lượng tồn của chứng từ <span class="color-green">{2}</span>. Số lượng tồn của chứng từ <span class="color-green">{2}</span> là: {3}. Ghi sổ không thành công.</div>',
  Post_ValidateOutwardQuantity:
    '<div class="content-error">Không thể xuất <span class="color-green">{0} - {1}</span> quá số tồn trong kho <span class="color-green">{2} - {3}</span>. Số tồn tính đến ngày <span class="color-green">{4}: {5}</span>. Ghi sổ không thành công.</div>',

  Post_ValidateOutwardQuantity_NoColor:
    'Không thể xuất {0} {1}-{2} quá số tồn trong kho {3}-{4}. Số tồn tính đến ngày {5}: {6}. Ghi sổ không thành công.',
  Post_ValidateToolQuantity_Decrement:
    'Không thể ghi giảm CCDC <span class="color-green">{0}-{1}</span> quá số tồn tại phòng ban <span class="color-green">{2}-{3}</span>. Số tồn CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolQuantity_Tranfer:
    'Không thể điều chuyển CCDC <span class="color-green">{0}-{1}</span> quá số tồn tại phòng ban <span class="color-green">{2}-{3}</span>. Số tồn CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolAmount_Decrement:
    'Không thể ghi giảm CCDC <span class="color-green">{0}-{1}</span> quá số dư tại phòng ban <span class="color-green">{2}-{3}</span>. Số dư CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_ValidateToolAmount_Tranfer:
    'Không thể điều chuyển CCDC <span class="color-green">{0}-{1}</span> quá số dư tại phòng ban <span class="color-green">{2}-{3}</span>. Số dư CCDC tính đến ngày {4}: {5}. Ghi sổ không thành công.',
  Post_VoucherInvalid_AccountParent: 'Không hạch toán vào tài khoản tổng hợp.',

  Post_ValidQuantityTool:
    '<div class="content-error">Số lượng CCDC <span class="color-green">{0}</span> đã ghi tăng cho phòng ban <span class="color-green">{1}</span> là <span class="color-green">{2}</span>. <br/>Bạn không thể ghi giảm với số lượng lớn hơn số lượng đã ghi tăng.</div>',
  Post_ValidQuantityTool_NoColor:
    'Số lượng CCDC {0} đã ghi tăng cho phòng ban {1} là {2}. Bạn không thể ghi giảm với số lượng lớn hơn số lượng đã ghi tăng.',
  Unpost_VoucherInvalidDate: 'Ngày hạch toán phải lớn hơn ngày khóa sổ. Xin vui lòng kiểm tra lại.',

  // Yes/no
  UnPost_ErrorUnPostExistInGLVoucherList:
    ' Chứng từ <span class="color-green">{0}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-green">{1}</span>/Chứng từ ghi sổ <span class="color-green">{1}</span>. Để bỏ ghi sổ <span class="color-green">{0}</span>, chương trình sẽ loại bỏ <span class="color-green">{0}</span> khỏi Chứng từ ghi sổ/Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
  Post_QuestionClosingDebit: `Số dư của tài khoản <span class="color-green"><{0}></span> đến ngày {1} chỉ còn {2}.</br>`,
  Post_QuestionPurchasePurpose:
    'Cần nhập thông tin "Nhóm HHDV" để lên Bảng kê hóa đơn, chứng từ hàng hóa, dịch vụ mua vào. Bạn có muốn ghi sổ không?',
  Post_Warning_OutwardBeUpdated:
    'Việc ghi sổ này sẽ dẫn đến các chứng từ <span class="color-blue">{0}</span> cũng sẽ được ghi sổ theo, bạn có tiếp tục không?',

  Post_EmptyIncrTool:
    '<div class="content-error"> Chưa ghi tăng CCDC <span class="color-green">{0}</span> thuộc Phòng ban <span class="color-green">{1}</span>. Bạn không thể ghi giảm Công cụ dụng cụ này.</div>',
  Post_EmptyIncrTool_NoColor: 'Chưa ghi tăng CCDC {0} thuộc Phòng ban {1}. Bạn không thể ghi giảm Công cụ dụng cụ này.',

  // Error code
  UnPost_ErrorExistInBUVoucherList_Code: 'UnPost_ErrorExistInBUVoucherList',
  UnPost_ErrorUnPostExistInGLVoucherList_Code: 'UnPost_ErrorUnPostExistInGLVoucherList',
  UnPost_Warning_OutwardBeUpdated_Code: 'UnPost_Warning_OutwardBeUpdated',
  UnPost_ReferenceToDvcFile: 'UnPost_ReferenceToDvcFile', // Lỗi khi bỏ ghi chứng từ tham chiếu đến hồ sơ trạng thái không hợp lệ
  // Title
  UnPost_ErrorExistInBUVoucherList_Title: 'Không thể bỏ ghi chứng từ',
  UnPost_Warning_OutwardBeUpdated_Title: 'Bỏ ghi sổ không thành công',
  // Button
  UnPost_ErrorExistInBUVoucherList_Button: 'Xem bảng kê',
  UnPost_Warning_OutwardBeUpdated_Button: 'Đồng ý',
  // Message
  UnPost_ErrorExistInBUVoucherList:
    'Cần thực hiện hủy thanh toán trước khi bỏ ghi chứng từ do chứng từ này đã thanh toán trên bảng kê <span class="color-green">{0}</span>.',
  UnPost_ErrorExistInBUVoucherList_Multi:
    'Chứng từ đã được thanh toán trên bảng kê số <span class="color-blue">{0}</span>.',
  UnPost_ErrorUnPostExistInGLVoucherList_All:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-blue">{0}</span> và Chứng từ ghi sổ <span class="color-blue">{2}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Chứng từ ghi sổ và Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
  UnPost_ErrorUnPostExistInGLVoucherList_Summary:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Bảng tổng hợp chứng từ cùng loại <span class="color-blue">{0}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Bảng tổng hợp chứng từ cùng loại. Bạn có muốn bỏ ghi không?',
  UnPost_ErrorUnPostExistInGLVoucherList_Voucher:
    'Chứng từ <span class="color-blue">{1}</span> đã được lập Chứng từ ghi sổ <span class="color-blue">{0}</span>. Để bỏ ghi sổ <span class="color-blue">{1}</span>, chương trình sẽ loại bỏ <span class="color-blue">{1}</span> khỏi Chứng từ ghi sổ. Bạn có muốn bỏ ghi không?',
  UnPost_ExpenseReceipt_Paid:
    'Cần thực hiện hủy Ghi thu - ghi chi trước khi bỏ ghi chứng từ do chứng từ này đã ghi thu - ghi chi trên bảng kê <span class="color-green">{0}</span>.',
  UnPost_AdvanceNSNN_Paid:
    'Cần thực hiện hủy Ghi thu trước khi bỏ ghi chứng từ do chứng từ này đã ghi thu trên bảng kê <span class="color-green">{0}</span>.',
  UnPost_AdvancePayment_Paid:
    'Cần thực hiện hủy thanh toán trước khi bỏ ghi chứng từ do chứng từ này đã thanh toán trên bảng kê <span class="color-green">{0}</span>.',
  UnPost_AdvanceNSNN_Paid_NoColor:
    'Cần thực hiện hủy Ghi thu trước khi bỏ ghi chứng từ do chứng từ này đã ghi thu trên bảng kê {0}.',
  UnPost_ExpenseReceipt_Paid_NoColor:
    'Cần thực hiện hủy Ghi thu - ghi chi trước khi bỏ ghi chứng từ do chứng từ này đã ghi thu - ghi chi trên bảng kê {0}.',
  UnPost_AdvancePayment_Paid_NoColor:
    'Cần thực hiện hủy thanh toán trước khi bỏ ghi chứng từ do chứng từ này đã thanh toán trên bảng kê {0}.',
  Post_VoucherHasReferenceOnly: 'Bỏ ghi chứng từ này đồng thời sẽ xóa bảng kê {0}.Bạn muốn bỏ ghi chứng từ này không?',

  // Message cho xóa nhiều và bỏ ghi chứng từ liên quan
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_Voucher: 'Chứng từ đã được lập Chứng từ ghi sổ {0}.',
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_Summary: 'Chứng từ đã được lập Bảng tổng hợp chứng từ cùng loại {0}.',
  DeleteUnPost_ErrorUnPostExistInGLVoucherList_All:
    'Chứng từ {1} đã được lập Bảng tổng hợp chứng từ cùng loại {0} và Chứng từ ghi sổ {2}.',

  // Mã lỗi chứng từ
  GENERATE_DATA: 'GENERATE_DATA',
  VALIDATE: 'VALIDATE',

  // Mã code lỗi
  Delete_ErrorIsPostedVoucher: 'Delete_ErrorIsPostedVoucher',
  Delete_ErrorRelationVoucher: 'Delete_ErrorRelationVoucher',
  Delete_ErrorRelationVoucherSummary: 'Delete_ErrorRelationVoucherSummary',
  Delete_ErrorIsPaymentVoucher: 'Delete_ErrorIsPaymentVoucher',
  Delete_ErrorIsPostedInvoice: 'Delete_ErrorIsPostedInvoice',
  Delete_ErrorReferenceInvoice: 'Delete_ErrorReferenceInvoice',
  Delete_ErrorInvoiceReferenceVoucher: 'Delete_ErrorInvoiceReferenceVoucher',
  Delete_ErrorReferenceSalary: 'Delete_ErrorReferenceSalary',
  Delete_ErrorTACircularVATAdditional: 'Delete_ErrorTACircularVATAdditional',
  Delete_ErrorTACircularVATAdditionalOther: 'Delete_ErrorTACircularVATAdditionalOther',
  Delete_ErrorIsParallelVoucher: 'Delete_ErrorIsParallelVoucher',

  // Message lỗi tương ứng với mã code

  Message_Delete_ErrorIsPostedVoucher: 'Không thể xóa chứng từ này do đã ghi sổ. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorIsPaymentVoucher: 'Bảng kê <span class="color-blue">{0}</span> đã được thanh toán.',
  Message_Delete_ErrorInvoiceReferenceVoucher:
    '<div>Hóa đơn <span class="color-blue">{0}</span> đã được lập kèm chứng từ bán hàng <span class="color-blue">{1}</span>.</div> <div>Bạn cần kiểm tra lại chứng từ bán hàng.</div>',
  Message_Delete_ErrorIsPostedInvoice:
    '<div>Hóa đơn <span class="color-blue">{0}</span> - <span class="color-blue">{1}</span> - <span class="color-blue">{2}</span> đã phát hành hóa đơn điện tử.</div> <div>Bạn không được phép xóa.</div>',
  Message_Delete_ErrorReferenceSalary: 'Đã sinh chứng từ liên quan. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorTACircularVATAdditional: 'Đã tồn tại tờ khai bổ sung. Vui lòng kiểm tra lại.',
  Message_Delete_ErrorTACircularVATAdditionalOther: 'Đã tồn tại tờ khai bổ sung lần {0}. Vui lòng kiểm tra lại.',
  Message_Post_ValidFixedAssetIncrement:
    'Tài sản <span class="color-green">{0}</span> đã được ghi tăng. Vui lòng kiểm tra lại',

  Message_Post_ValidFixedAssetDecrement:
    'Tài sản <span class="color-green">{0}</span> đã được ghi giảm. Vui lòng kiểm tra lại',
  Message_Delete_ErrorIsParallelVoucher: 'Không thể xóa chứng từ ghi đồng thời',

  // Message_Delete_ErrorRelationVoucher: 'Chứng từ này đã được ghi sổ. Vui lòng kiểm tra lại.',

  // Mã lỗi ghi sổ VTHH
  Post_ValidConfrontingRefIDForRealNameCode: 'Post_ValidConfrontingRefIDForRealName',
  Post_ValidateOutwardQuantityRealNameCode: 'Post_ValidateOutwardQuantityRealName',
  Post_ValidateOutwardQuantityCode: 'Post_ValidateOutwardQuantity',

  Post_ValidFixedAssetIncrement: 'Post_ValidFixedAssetIncrement',
  Post_ValidFixedAssetDecrement: 'Post_ValidFixedAssetDecrement',

  Post_ValidQuantityToolCode: 'Post_ValidQuantityTool',
  Post_ValidAmountToolCode: 'Post_ValidAmountTool',

  Post_RequireAccountingInfo: 'Thiếu thông tin hạch toán. Vui lòng kiểm tra lại.',

  Maintain_PostUnvalidateCloseDate: 'Lỗi ngày hạch toán nhỏ hơn hoặc bằng ngày khóa sổ',

  PostedErrorCode_Post_ValidAmountNegative: 'Post_ValidAmountNegative',
  PostedErrorCode_Post_PostToAssetOverOutwardStock: 'Post_PostToAssetOverOutwardStock',
  PostedErrorCode_Post_OverOutwardStock: 'Post_OverOutwardStock',
   PostedErrorCode_Post_OverOutwardStockByObjectDecision: 'Post_OverOutwardStockByObjectDecision',
  PostedErrorCode_Post_AccountNotExist: 'Post_AccountNotExist',
  PostedErrorCode_Post_MissingDistribution: 'Post_MissingDistribution',

  // Các lỗi khi thực hiện ghi sổ
  Post_ValidAmountNegative:
    'Số dư của TK <b>{0}</b> đến ngày <b>{1}</b> chỉ còn <b>{2}</b>. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?',
  Post_ValidAmountNegativeWithJustice:
    'Số dư của TK <b>{0}</b> theo QĐ <b>{1}</b> đến ngày <b>{2}</b> chỉ còn <b>{3}</b>. Bạn có muốn ghi sổ (chấp nhận xuất quỹ tiền âm) không?',
  Post_VoucherInvalid_AccountParent:
    'Tài khoản ghi sổ là tài khoản tổng hợp (là tài khoản cha của các tài khoản con khác)',
  Post_VoucherInvalid_InvalidCurrencyID: 'Lỗi khi ghi chứng từ vào sổ cái: nhập sai loại tiền.',
  Post_VoucherInvalid_InvalidCurrencyIDOrther: 'Tồn tại dòng hạch toán sai loại tiền. Vui lòng kiểm tra lại',
  Post_VoucherInvalid_RequiredBankAccountMater: 'Bạn chưa nhập tài khoản ngân hàng, kho bạc',
  Post_VoucherInvalid_AccountTransferMissing:
    'Thiếu chứng từ phân phối cho tài khoản <b>{0}</b> theo quyết định số <b>{1}</b>, đối tượng <b>{2}</b>. Ghi sổ không thành công.',
  Post_VoucherInvalid_AccountTransferNotEnough: `Chi quá số tiền trên chứng từ kết chuyển <b>{0}</b> cho tài khoản <b>{1}</b>, theo quyết định số <b>{2}</b>, đối tượng <b>{3}</b>. Ghi sổ không thành công.`,
  Post_VoucherInvalid_CheckCreateParallelVoucher: 'Bạn có muốn sinh chứng từ ghi đồng thời không?',
  Post_VoucherInvalid_NotExistsMovementWithJusticeAndObject:
    'Thiếu chứng từ kết chuyển cho tài khoản <b>{0}</b> theo quyết định số <b>{1}</b>, đối tượng <b>{2}</b>. Vui lòng kiểm tra lại.',
  Post_VoucherInvalid_AmountPaymentGreaterReceiptWithObjectAndJustice:
    'Số tiền chuyển trả đối tượng vượt quá số tiền tạm thu của đối tượng <b>{0}</b> và quyết định số <b>{1}</b>. Vui lòng kiểm tra lại.',
  Post_PostToObject_ObjectMissing: 'Lỗi khi ghi chứng từ vào sổ chi tiết đối tượng: thiếu mã đối tượng.',
  Post_PostToDecisionObject_DecisionMissing:
    'Lỗi khi ghi chứng từ vào sổ chi tiết theo quyết định và đối tượng: thiếu mã số quyết định.',
  Post_PostToDecisionObject_ExecutorMissing:
    'Lỗi khi ghi chứng từ vào sổ chi tiết theo quyết định và đối tượng: thiếu chấp hành viên.',
  Post_PostToDecisionObject_ObjectMissing:
    'Lỗi khi ghi chứng từ vào sổ chi tiết theo quyết định và đối tượng: thiếu mã đối tượng.',
  Post_SelectOneListCode: 'Thiếu mã thống kê!.',
  Post_NoAccountSelected: 'Chưa chọn tài khoản hạch toán tại phần chi tiết.',
  Post_WarningEmptyJusticeDecision: 'Quyết định không được để trống.',
  Post_WarningEmptyObject: 'Đối tượng không được để trống.',
  Post_PostToAssetOverOutwardStock:
    'Tài sản {0} xuất kho chuyển trả {1} vượt quá số tài sản nhập kho {2}. Số lượng tồn tính đến ngày {3} là {4}.',
  Post_OverOutwardStock: 'Không được xuất tài sản <b>{0}</b> quá số lượng tồn trong kho <b>{1}</b>. Số tồn tính đến ngày <b>{2}</b>: <b>{3}</b>. Vui lòng kiểm tra lại.',
  Post_OverOutwardStockByObjectDecision: 'Tài sản <b>{0}</b> xuất kho chuyển trả đối tượng <b>{1}</b> theo quyết định <b>{2}</b> vượt quá số tài sản nhập kho <b>{3}</b>. Số lượng tồn tính đến ngày <b>{4}</b> là <b>{5}</b>',
  Post_InvalidAssetID: 'Mã tài sản không hợp lệ.',
  Post_InvalidStockID: 'Mã kho không hợp lệ.',
  Post_AccountNotExist: '{0} không tồn tại trong hệ thống tài khoản.',
  Post_MissingDistribution: 'Thiếu chứng từ phân phối cho tài khoản <b>{0}</b> theo quyết định số <b>{1}</b>, đối tượng <b>{2}</b>. Vui lòng kiểm tra lại.',

  Message_Object_Alias: 'đối tượng <{0}>',
  Message_Justice_Decision_Alias: 'đối tượng <{0}>',
};
